'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutCluster, LayoutStack } from 'design-system/client';
import styles from './IFrameAddressFields.module.css';
import CityField from '@/donationPages/_dependencies/components/formParts/AddressFields/CityField';
import CountryField from '@/donationPages/_dependencies/components/formParts/AddressFields/CountryField';
import StreetField from '@/donationPages/_dependencies/components/formParts/AddressFields/StreetField';
import type { AddressFieldsProps } from '@/donationPages/_dependencies/components/formParts/AddressFields/types';
import ZipField from '@/donationPages/_dependencies/components/formParts/AddressFields/ZipField';
function IFrameAddressFields(t0) {
  const $ = _c(9);
  const {
    required
  } = t0;
  let t1;
  if ($[0] !== required) {
    t1 = <StreetField required={required} />;
    $[0] = required;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== required) {
    t2 = <LayoutCluster space="300" className={styles.cityContainer}><CityField required={required} /><ZipField required={required} /></LayoutCluster>;
    t3 = <CountryField required={required} />;
    $[2] = required;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <LayoutStack space="400">{t1}{t2}{t3}</LayoutStack>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export default IFrameAddressFields;